import request from 'superagent'
import types from '../types'

const { api_port } = require('../../../package.json')

const { protocol, hostname } = window.location
let api_url = `${protocol}//${hostname}:${api_port}/api`
if (api_port === '') {
  api_url = `${protocol}//${hostname}/api`
}

const getCitiesRequested = () => ({
    type: types.GET_CITIES_REQUESTED,
    payload: null
})

const getCitiesFufilled = (data) => ({
    type: types.GET_CITIES_FULFILLED,
    payload: data
})

const getCitiesRejected = (error) => ({
    type: types.GET_CITIES_REJECTED,
    payload: error
})

export const getCities = (token: string) => {
    return (dispatch: any) => {
        dispatch(getCitiesRequested())
        request
            .get(`${api_url}/cities`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getCitiesFufilled(response.body))
            })
            .catch((error) => {
                dispatch(getCitiesRejected(error))
            })
    }
}

const getStatesRequested = () => ({
    type: types.GET_STATES_REQUESTED,
    payload: null
})

const getStatesFufilled = (data) => ({
    type: types.GET_STATES_FULFILLED,
    payload: data
})

const getStatesRejected = (error) => ({
    type: types.GET_STATES_REJECTED,
    payload: error
})

export const getStates = (token: string) => {
    return (dispatch: any) => {
        dispatch(getStatesRequested())
        request
            .get(`${api_url}/states`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getStatesFufilled(response.body))
            })
            .catch((error) => {
                dispatch(getStatesRejected(error))
            })
    }
}

const getCountiesRequested = () => ({
    type: types.GET_COUNTIES_REQUESTED,
    payload: null
})

const getCountiesFulfilled = (data) => ({
    type: types.GET_COUNTIES_FULFILLED,
    payload: data
})

const getCountiesRejected = (error) => ({
    type: types.GET_COUNTIES_REJECTED,
    payload: error
})

export const getCounties = (token: string) => {
    return (dispatch: any) => {
        dispatch(getCountiesRequested())
        request
            .get(`${api_url}/counties`)
            .set('Accept', 'application/json')
            .set('access-token', token)
            .then((response) => {
                dispatch(getCountiesFulfilled(response.body))
            })
            .catch((error) => {
                dispatch(getCountiesRejected(error))
            })
    }
}